import { RIGHTS_REQUEST, CREATE_RIGHTS, GET_RIGHTS, UPDATE_RIGHTS, DELETE_RIGHTS, RIGHTS_REQUEST_FAILURE, GET_AUTHORIZE_COMPANIES } from '../types';

const initialState = {
  rights: [],
  authorizeCompanies: [],
  loading: false,
  error: null,
};

const userRightReducer = (state = initialState, action) => {
  switch (action.type) {
    case RIGHTS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_RIGHTS: {
      return {
        ...state,
        rights: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_RIGHTS:
      return {
        ...state,
        rights: [action.payload, ...state.rights],
        loading: false,
        error: null
      };
    case UPDATE_RIGHTS:
      const rightsData = state.rights.slice(0);
      const uIndex = rightsData.findIndex((data) => data.id === action.payload.id);
      rightsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        rights: [ ...rightsData ],
        loading: false,
        error: null
      };
    case DELETE_RIGHTS:
      const rights = state.rights?.slice(0);
      const index = rights.findIndex((data) => data.id === action.id);
      if (index > -1) {
        rights.splice(index, 1);
      }
      return {
        ...state,
        rights: [...rights],
        loading: false,
        error: null
      }
    case GET_AUTHORIZE_COMPANIES: {
      return {
        ...state,
        authorizeCompanies: [...action.payload],
        loading: false,
        error: null
      }
    }
    case RIGHTS_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
    }
};

export default userRightReducer;
